var map = {
	"./alergie-alergia.jpg": 41,
	"./autyzm-dzieciecy.jpg": 481,
	"./borelioza-kleszcz.jpg": 541,
	"./dzieciecy-autyzm.jpg": 783,
	"./granulki-homeopatyczne.jpg": 818,
	"./hipogonadyzm.jpg": 373,
	"./krople-lecznicze.jpg": 83,
	"./kurzajki.jpg": 253,
	"./leczenie-borelioza.jpg": 215,
	"./leczenie-holistyczne.jpg": 592,
	"./lek-przedszkolny.jpg": 23,
	"./narkolepsja.jpg": 360,
	"./niepokoj-niemowlecia.jpg": 349,
	"./rozlinne-leki-homeopatyczne.jpg": 650,
	"./terapia-powypadkowa-cefalgia.jpg": 3,
	"./wypadek-motocyklowy-uraz-glowy.jpg": 81,
	"./zapalenie-oskrzeli.jpg": 451,
	"./zapalenie-zatok.jpg": 825,
	"./zmiany-skorne.jpg": 852
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 454;